import type { NotificationProps } from '../notification'

import { igaoPages } from '../../igao/utils'
import { Notification } from '../notification'

export interface IgaoNotificationProps extends NotificationProps {
  path: string
  user: {
    name: string
  }
  time: string
  id: string
}

export function IgaoNotification ({
  id,
  user,
  time,
  path,
  ...rest
}: IgaoNotificationProps): JSX.Element {
  let page = igaoPages.find(i => i.id === path)?.name ?? path

  return (
    <Notification
      id={id}
      date={new Date(time)}
      title='Questionnaire Updated'
      {...rest}
    >
      {page} questionnaire updated by {user.name}
    </Notification>
  )
}
